var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4591 6.26145L14.5755 6.49701L14.8356 6.53476L20.5705 7.36743C21.411 7.48951 21.7452 8.52021 21.1385 9.11137C21.1384 9.11141 21.1384 9.11145 21.1383 9.11149L16.9883 13.1509L16.7998 13.3344L16.8443 13.5938L17.8234 19.3013L17.8234 19.3013C17.9666 20.1358 17.0898 20.7742 16.3373 20.379L16.3372 20.379L11.2066 17.6859L10.9742 17.564L10.7418 17.6859L5.61122 20.379L5.61114 20.379C4.85861 20.7742 3.98183 20.1358 4.12501 19.3013C4.12501 19.3013 4.12501 19.3013 4.12501 19.3013L5.10461 13.5951L5.14913 13.3358L4.96058 13.1522L0.810886 9.11271C0.81088 9.1127 0.810874 9.1127 0.810868 9.11269C0.203684 8.52154 0.537815 7.49082 1.37835 7.36873L7.11374 6.53607L7.37377 6.49832L7.49017 6.26276L10.0554 1.07149C10.4326 0.309096 11.5185 0.310412 11.8938 1.06998L14.4591 6.26145Z",
    fill: "#FCFC30",
    stroke: "#69696E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.de51527346ca3acc0b4a1f628500184c.svg";
export { ForwardRef as ReactComponent };